import React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ClientVoiceCarousel() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const testimonials = [{
    quote: "Highly recommend Clint, he helped transform our space and get it ready for sale. Great guy, easy to work with.",
    author: "Jodie Kay",
    role: ""
  }];
  return <section data-section-id="23557" id="trusted-by-your-neighbors" ref={ref} className={`w-full py-24 dark bg-background text-foreground transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-4xl mx-auto px-6 relative">
        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center text-center px-4 md:px-12 py-8">
                  {}
                  <blockquote className="font-sans italic text-[24px] md:text-[32px] leading-tight text-foreground mb-8 max-w-3xl tracking-tight">
                    &ldquo;{testimonial.quote}&rdquo;
                  </blockquote>

                  {}
                  <div className="flex gap-1 mb-6">
                    {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="w-5 h-5 fill-accent text-accent" strokeWidth={0} />)}
                  </div>

                  {}
                  <div className="flex flex-col items-center gap-1">
                    <span className="text-foreground font-bold text-lg font-sans">
                      {testimonial.author}
                    </span>
                    <span className="text-muted-foreground text-sm font-medium uppercase tracking-widest">
                      {testimonial.role}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="hidden md:block">
            <CarouselPrevious variant="ghost" className="h-12 w-12 text-muted-foreground hover:text-foreground hover:bg-transparent -left-16 border-none [&_svg]:size-6" />
            <CarouselNext variant="ghost" className="h-12 w-12 text-muted-foreground hover:text-foreground hover:bg-transparent -right-16 border-none [&_svg]:size-6" />
          </div>
        </Carousel>
      </div>
    </section>;
}